import * as axios from '@/axios';
import { getLanguage } from '@/i18n';
import MyLog from '@/script/my-log.js';

// import router from '@/router'
// import util from '@/script/util'
let mySkills = localStorage.getItem('mySkills');
if (mySkills) {
  mySkills = JSON.parse(mySkills);
}
const isProd = process.env.VUE_APP_ENV === 'production';

const state = () => ({
  token: null, // token
  refreshToken: null, // refreshToken
  userInfo: null, // 用户信息
  accountInfo: {}, // 账户信息
  bossescount: {
    newBossCount: 0,
    regularCount: 0
  }, // 待维系客户信息
  masterInfo: {}, // 我的B端詳情信息
  adminUuid: isProd ? '1896455' : '237731', // 管理员账号用與動態公告發布
  systemUuid: isProd ? ['1896455'] : ['237731'], // 官方帳號
  abTest: {}, // abTest
  mySkills: mySkills || [], // 我的常用技能
  showNewerReward: false, // 显示红包弹窗
  newDiscount: null, // 新获取的红包信息
  firstRecharge: false, // 新人首充优惠资格
  isAllowThirty: true // 是否允許使用第三方儲值
});

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_REFRESH_TOKEN: (state, refreshToken) => {
    state.refreshToken = refreshToken;
  },
  SET_USER_INFO: (state, user) => {
    state.userInfo = user;
    if (user) {
      MyLog.setUser({ id: user.uuid, name: user.nickname });
    }
  },
  SET_ACCOUNT_INFO: (state, account) => {
    state.accountInfo = account;
  },
  SET_BOSSES_COUNT: (state, bossescount) => {
    state.bossescount = bossescount;
  },
  SET_MASTER_INFO: (state, data) => {
    state.masterInfo = data;
  },
  SET_AB_TEST: (state, abTest) => {
    state.abTest = abTest;
  },
  SET_MY_SKILLS: (state, list) => {
    state.mySkills = list;
  },
  SET_NEW_DISCOUNT: (state, newDiscount) => {
    state.newDiscount = newDiscount;
  },
  SHOW_NEWER_REWARD: (state, payload) => {
    state.showNewerReward = payload;
  },
  SET_FIRST_RECHARGE: (state, payload) => {
    state.firstRecharge = payload;
  },
  SET_ALLOW_THIRTY_RECHARGE: (state, payload) => {
    state.isAllowThirty = payload;
  }
};

const actions = {
  setFirstRecharge({ commit }) {
    axios.get('/reddot/info').then(({ data: { firstRecharge } }) => {
      commit('SET_FIRST_RECHARGE', firstRecharge);
    });
  },
  setToken({ commit }, token = null) {
    commit('SET_TOKEN', token);
  },
  setRefreshToken({ commit }, refreshToken = null) {
    commit('SET_REFRESH_TOKEN', refreshToken);
  },
  setUser({ commit, state, dispatch }, user = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get('/user/info')
        .then(({ data, code }) => {
          if (data) {
            commit(
              'SET_USER_INFO',
              Object.assign(data, user, {
                userId: data.uuid
              })
            );
            if (JSON.stringify(state.accountInfo) === '{}') {
              dispatch('setAccount');
            }
            if (data.userKind === 'Player') {
              dispatch('setMasterInfo');
            }
            getLanguage(data.language, { source: 'backend' });
            dispatch('setABTest');
          }
          resolve(code == 200);
        })
        .catch(reject);
    });
  },
  clearUserInfo({ commit }) {
    commit('SET_USER_INFO', null);
    commit('SET_ACCOUNT_INFO', {});
    commit('SET_AB_TEST', {});
  },
  setAccount({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/user/account')
        .then(({ data }) => {
          if (data) {
            commit('SET_ACCOUNT_INFO', data);
          }
          resolve(data);
        })
        .catch(reject);
    });
  },
  setBossesCount({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post('/myBoss/bossesCount', {})
        .then(({ data }) => {
          if (data) {
            commit('SET_BOSSES_COUNT', data);
          }
          resolve(data);
        })
        .catch(reject);
    });
  },
  setABTest({ commit }) {
    axios
      .get('/ab/getAb')
      .then(({ data }) => {
        commit('SET_AB_TEST', data);
      })
      .catch(e => {
        console.log(e);
      });
  },
  closeNewerReward({ commit }) {
    commit('SHOW_NEWER_REWARD', false);
  },
  setMasterInfo({ commit, state }) {
    return axios
      .get('master/detail', {
        uuid: state.userInfo ? state.userInfo.uuid : ''
      })
      .then(({ data }) => {
        if (data) {
          commit('SET_MASTER_INFO', data);
        }
      });
  },
  setMySkills({ commit }, list = []) {
    localStorage.setItem('mySkills', JSON.stringify(list));
    commit('SET_MY_SKILLS', list);
  },
  showRedbagDialog: ({ commit, dispatch }, couponTemplate) => {
    dispatch('setAccount');
  },
  setAllowThirtyRecharge({ commit }) {
    //允许第三方储值
    return new Promise((resolve, reject) => {
      commit('SET_ALLOW_THIRTY_RECHARGE', true)
    });
    //弃用接口控制
    // return new Promise((resolve, reject) => {
    //   axios
    //     .get('/iap/yao')
    //     .then(({ data }) => {
    //       commit('SET_ALLOW_THIRTY_RECHARGE', data);
    //       resolve(data);
    //     })
    //     .catch(()=>{
    //       commit('SET_ALLOW_THIRTY_RECHARGE', true)
    //       reject(false)
    //     });
    // });
  }
};

const getters = {
  token: state => state.token,
  refreshToken: state => state.refreshToken,
  userInfo: state => state.userInfo,
  accountInfo: state => state.accountInfo,
  bossescount: state => state.bossescount
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
